<div
  class="inner-mat-dialog title-section flex content-stretch items-stretch flex-col dialog-box-merge-quarantine-drug">
  <h1 mat-dialog-title class="title-text-red">
    {{alertWizardTitle}}
    <button class="close" (click)="closeDialog(false)"></button>
  </h1>
  <mat-dialog-content class="body-messge">
    <form [formGroup]="saveQuarantineDrugFormModal" style="overflow:scroll">

      <!-- DRUG NAME -->
      <ng-container *ngIf="showDrugName()">
        <div class="flex flex-col">
          <span class="label">Drug Name</span>
          <input type="text" aria-label="Drug Name" matInput [formControl]="drugName"
            [matAutocomplete]="autoDrugName" />
          <mat-autocomplete #autoDrugName="matAutocomplete" [displayWith]="displayFnDrugName.bind(this)">
            <mat-option *ngFor="let data of listOfDrugName" [value]="data.label">
              {{ data.label }}
            </mat-option>
            <mat-option *ngIf="isLoading" class="is-loading">
              <mat-spinner diameter="25"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="saveQuarantineDrugFormModal.get('drugName')?.errors as errors">
            <div *ngIf="errors['leadingSpace']">{{ errors['leadingSpace'] }}</div>
          </mat-error>
        </div>
      </ng-container>
      <!-- STRENGTH & UNIT IN SINGLE ROW -->
      <ng-container *ngIf="showStrengthAndUnit()">
        <div class="flex flex-col mt-4">
          <div class="flex flex-row gap-4">
            <div class="flex flex-col basis-1/2">
              <span class="label">Strength</span>
              <input type="text" matInput formControlName="strength" />
            </div>
            <div class="flex flex-col basis-1/2">
              <span class="label">Unit</span>
              <input type="text" matInput formControlName="unit" />
            </div>
          </div>
        </div>
      </ng-container>
    </form>

  <hr />

  <!-- Suggestions Table Section -->
  <h1 class="master-drug-test-records">
    Master Source Records
  </h1>
  <div class="suggestions-table-container" *ngIf="suggestionList.length > 0">
    <table mat-table [dataSource]="suggestionList" class="suggestions-table">

      <!-- Radio Button for selection of drug -->
      <!-- Radio Button Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-radio-button
            name="suggestionRadio"
            [value]="i"
            [checked]="selectedSuggestionIndex === i"
            (change)="onSuggestionRowSelect(element, i)"
            [disabled]="isRowDisabled(element)"
            >
          </mat-radio-button>
        </td>
      </ng-container>

      <!-- Drug Number Column -->
      <ng-container matColumnDef="drugNumber">
        <th mat-header-cell *matHeaderCellDef>Drug Number</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.drugNumber}}
        </td>
      </ng-container>

      <!-- Drug Name Column -->
      <ng-container matColumnDef="drugName">
        <th mat-header-cell *matHeaderCellDef>Drug Name</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.drugName}}
        </td>
      </ng-container>

      <!-- Generic Name Column -->
      <ng-container matColumnDef="genericName">
        <th mat-header-cell *matHeaderCellDef>Generic Name</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.genericName}}
        </td>
      </ng-container>

      <!-- Strength Column -->
      <ng-container matColumnDef="strength">
        <th mat-header-cell *matHeaderCellDef>Strength</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.strength}}
        </td>
      </ng-container>

      <!-- Unit Column -->
      <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef>Unit</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.unitDescription}}
        </td>
      </ng-container>

      <!-- Source Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef>Source</th>
        <td mat-cell *matCellDef="let element"
            [class.disabled-row]="isRowDisabled(element)">
          {{element.source}}
        </td>
      </ng-container>

    <!-- MFG Column -->
    <ng-container matColumnDef="mfg">
      <th mat-header-cell *matHeaderCellDef>MFG</th>
      <td mat-cell *matCellDef="let element"
          [class.disabled-row]="isRowDisabled(element)">
        {{element.mfg}}
      </td>
    </ng-container>

      <tr mat-header-row *matHeaderRowDef="getDisplayedColumnsWithRadio()"></tr>
      <tr mat-row *matRowDef="let row; columns: getDisplayedColumnsWithRadio();" [class.disabled-row]="isRowDisabled(row)"></tr>
    </table>
  </div>

  </mat-dialog-content>

  <mat-dialog-actions class="flex flex-column !flex-start content-end items-end w-full xs:flex xs:flex-col" style="margin-bottom: '1rem'">

    <div class="toggle-permanent-quarantine">
      <span class="question">Do you want to make this drug as permanent Quarantine?</span>
      <mat-radio-group formControlName="permanentQuarantine" class="quarantine-options" (change)="onPermanentQuarantineChange($event)">
        <mat-radio-button value="yes">Yes</mat-radio-button>
        <mat-radio-button value="no">No</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="flex flex-row justify-end content-end items-end w-full xs:flex xs:flex-col">
      <button mat-button class="btn-blue-light btn-md" (click)="closeDialog(true)" id="CancelNewUser"
        aria-label="Cancel" type="button">
        Cancel
      </button>
      <button mat-button aria-label="Done"
        (click)="updateDrug()"
        [ngClass]="{'btn-primary':saveQuarantineDrugFormModal?.valid, 'btn-disabled':!saveQuarantineDrugFormModal?.valid}"
        [disabled]="disableQuarantineDrugSubmitBtn()" class="btn-primary btn-md" type="button">Submit
      </button>
    </div>

  </mat-dialog-actions>
</div>
